import React from "react";

const BaseLoader = () => {
  return (
    <div className="w-12 h-12 border-4 border-t-4 border-gray-200 border-t-[#5465FF] rounded-full animate-spin"></div>
  );
};

export default BaseLoader;
